
import { Options, Vue } from "vue-class-component";
import { reactive } from "vue";
import PromotionalSMSService from "../service/PromotionalSMSService.js";
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import Toaster from "../helpers/Toaster";
import axios from "axios";
import FileUploader from "../components/FileUploader.vue";
import StockService from "../service/StockService";
import Textarea from "primevue/textarea";
import Chips from "primevue/chips";

@Options({
    props: {
        promotionDetail: Object,
        remainingSMSQuota: {
            type: Number,
            required: true,
        },
    },
    components: {
        FileUploader,
        Chips,
    },
    watch: {
        promotionDetail(obj) {
            if (obj.statusType == "New") {
                this.previewOnly = false;
                this.openDialog();
            } else if (obj.statusType == "Update") {
                this.previewOnly = false;
                this.item.id = obj.profilerID;
                this.editIem();
            } else if (obj.statusType == "Preview") {
                this.previewOnly = true;
                this.item.id = obj.profilerID;
                this.editIem();
            } else {
                this.dialogTitle = "";
            }

            this.dialogTitle = obj.dialogTitle;
            this.productDialog = obj.status;
            this.currentUserID = obj.currentUserID;
        },
    },
    emits: ["updatePromotionStatus", "updatePackageData"],
})
export default class PromotionalSMSDialog extends Vue {
    private toast;
    private submitted = false;
    private productDialog = false;
    private previewOnly = false;

    private dialogTitle = "";
    private popupDialogTitle = "Notification";
    private notificationDialogBody = "";
    private promotionalSMSService;
    private currentUserID = 0;
    private uploaderStatus = false;
    private statusDialog = false;
    private stockService = new StockService();
    private excelFileContent: string[] = [];
    private remainingSMSQuota!: number;
    private newContactNumbers: string[] = [];
    private contactNumbersCount = 0;
    private incorretContactNumbers: string[] = [];
    private editingNumber = "";
    private editingNumberIndex = 0;
    private completeNumbersChecking = false;
    private item = {
        id: 0,
        message: "",
        nationalId: "",
        contactNumbers: "",
        maskType: { key: "Doc990" },
        status: "Pending 1",
    };

    private state = reactive({
        promotionName: "",
        message: "",
        contactNumbers: "",
    });

    private validationRules = {
        promotionName: { required },
        message: { required },
        contactNumbers: { required },
    };

    private v$ = useVuelidate(this.validationRules, this.state);

    private maskTypes = [
        { key: "Doc990" },
        //{ key: "Pharmacy" },
    ];

    created() {
        this.promotionalSMSService = new PromotionalSMSService();
        this.toast = new Toaster();
    }

    openDialog() {
        this.submitted = false;
        this.productDialog = true;
        this.clearItems();
    }

    clearItems() {
        this.item = {
            id: 0,
            message: "",
            nationalId: "",
            contactNumbers: "",
            maskType: { key: "Doc990" },
            status: "",
        };
        this.state.promotionName = "";
        this.state.message = "";
        this.state.contactNumbers = "";
        this.incorretContactNumbers = [];
        this.newContactNumbers = [];
    }

    closeDialog() {
        this.$emit("updatePromotionStatus", ["", {}]);
        this.productDialog = false;
        this.statusDialog = false;
    }

    EditInvalidContact(editingNumberIndex) {
        this.editingNumber = this.incorretContactNumbers[editingNumberIndex];
        this.incorretContactNumbers.splice(editingNumberIndex, 1);
    }
    removeInvalidContact(index) {
        this.incorretContactNumbers.splice(index, 1);
    }

    removeNumberPrefix(number) {
        if (number.startsWith("+94")) {
            const remainingPart = number.slice(3);
            return remainingPart;
        } else if (number.startsWith("94")) {
            const remainingPart = number.slice(2);
            return remainingPart;
        } else if (number.startsWith("0")) {
            const remainingPart = number.slice(1);
            return remainingPart;
        } else {
            return number;
        }
    }

    UpdateInvalidContact() {
        if (this.editingNumber !== "") {
            this.editingNumber = this.removeNumberPrefix(this.editingNumber);

            if (this.isValidPhoneNumber(this.editingNumber)) {
                this.state.contactNumbers = this.newContactNumbers.join(", ");
                this.newContactNumbers = this.state.contactNumbers
                    ? this.state.contactNumbers
                          .split(",")
                          .map((item) => item.trim())
                    : [];
                this.newContactNumbers.push(this.editingNumber);
                if (this.state.contactNumbers !== "") {
                    this.state.contactNumbers =
                        this.newContactNumbers.join(", ");
                } else {
                    this.state.contactNumbers = this.editingNumber;
                }

                this.completeNumbersChecking = true;
                this.editingNumber = "";
            } else {
                this.toast.showError("Invalid Number");
            }
        }
    }

    countPhoneNumbersinField() {
        this.newContactNumbers = this.state.contactNumbers
            .split(",")
            .map((item) => item.trim());
        this.contactNumbersCount = this.newContactNumbers.length;
        return this.contactNumbersCount;
    }

    savePromotion(isFormValid) {
        this.state.contactNumbers = this.newContactNumbers.join(", ");
        // Check if form is valid
        if (isFormValid && this.newContactNumbers.length > 0) {
            if (this.completeNumbersChecking) {
                this.promotionalSMSService
                    .saveItem(this.item, this.state, this.currentUserID)
                    .then((res) => {
                        this.$emit("updatePromotionStatus", [
                            "load",
                            res.promotionDetail,
                        ]);

                        this.toast.handleResponse(res);
                    });
                this.submitted = true;
                this.productDialog = false;
                this.clearItems();
            }
        } else {
            this.toast.showError("Invalid Form");
        }
    }

    editIem() {
        this.submitted = false;
        this.dialogTitle = "Update Promotion";
        this.productDialog = true;
        this.promotionalSMSService.getItem(this.item).then((res) => {
            if (res.length > 0) {
                this.state.promotionName = res[0].promotion_name;
                this.state.message = res[0].message ?? "";
                this.state.contactNumbers = res[0].contact_numbers ?? "";
                this.item.maskType.key = res[0].mask_type;
                this.item.status = res[0].status;
            }
        });
    }

    openFileUploader() {
        this.uploaderStatus = true;
    }

    updateUploaderStatus(params: any[]) {
        this.uploaderStatus = false;

        if (params.length > 0) {
            this.excelFileContent = [];

            if (!this.stockService) {
                return;
            }

            this.stockService.uploadCSVFile(params[0]).then((res: any[]) => {
                if (res.length > 0) {
                    res.forEach((e) => {
                        if (e[0] !== "Phone Number" && e[0] !== null) {
                            this.excelFileContent.push(e[0]);
                        }
                    });

                    this.state.contactNumbers =
                        this.excelFileContent.join(", ");
                    this.countPhoneNumbersinField();
                    this.checkAllNumbersValidity();
                }
            });
        }
    }

    checkAllNumbersValidity() {
        let incorrectNumberPlace = 0;
        let corretContactNumbers: string[] = [];
        let over = false;
        let correctNumIndex = 0;
        let inCorrectNumIndex = 0;

        for (let index = 0; index < this.newContactNumbers.length; index++) {
            let item = this.newContactNumbers[index];

            item = this.removeNumberPrefix(item);

            if (this.isValidPhoneNumber(item) === false) {
                this.incorretContactNumbers[inCorrectNumIndex] = item;
                inCorrectNumIndex += 1;
            } else {
                corretContactNumbers[correctNumIndex] = item;
                correctNumIndex += 1;
            }

            if (index === this.newContactNumbers.length - 1) {
                this.completeNumbersChecking = true;
            }
        }

        this.newContactNumbers = corretContactNumbers;
        this.state.contactNumbers = this.newContactNumbers.join(", ");
    }

    // isValidPhoneNumber(phoneNumber) {
    //       // Ensure the input is a string and contains only digits
    //       if (typeof phoneNumber !== 'string' || !/^\d+$/.test(phoneNumber)) {
    //         return false;
    //       }

    //       // Check if the length is either 9 or 10
    //       if (phoneNumber.length === 10) {
    //         // 10-digit numbers must start with 0
    //         return phoneNumber[0] === '0';
    //       } else if (phoneNumber.length === 9) {
    //         // 9-digit numbers must not start with 0
    //         return phoneNumber[0] !== '0';
    //       }

    //       // Invalid if the length is not 9 or 10
    //       return false;
    // }

    isValidPhoneNumber(phoneNumber) {
        // Ensure the input is a string
        if (typeof phoneNumber !== "string") {
            return false;
        }

        // if (phoneNumber.startsWith('+94')) {

        //     // Remove +94 and validate the remaining part
        //     const remainingPart = phoneNumber.slice(3); // Get the part after +94
        //     // Ensure the remaining part has exactly 9 digits and does not start with 0
        //     return /^\d{9}$/.test(remainingPart) && remainingPart[0] !== '0';
        // }

        // Check for 9 or 10 digit local format
        if (/^\d+$/.test(phoneNumber)) {
            if (phoneNumber.length === 10) {
                // 10-digit numbers must start with 0
                return phoneNumber[0] === "0";
            } else if (phoneNumber.length === 9) {
                // 9-digit numbers must not start with 0
                return phoneNumber[0] !== "0";
            }
        }

        // Invalid for all other cases
        return false;
    }

    get smsPerNumber() {
        return this.state.message.length > 160 ? 2 : 1;
    }
}
